import { useRef, useState } from "react";

import { usePathname } from "next/navigation";

import { useFeature } from "shared/utils/hooks/useFeature";
import useWindowSize from "shared/utils/hooks/useWindowSize";

export const useGroupSearch = () => {
  const [hasErrorInRequest, sethasErrorInRequest] = useState(false);
  const pathname = usePathname();
  const { width } = useWindowSize();

  const isSearchEnabled = useFeature("f_search");
  const isInSearchPage = pathname === "/search";
  const isMobile = width <= 850;

  const alreadyFetchedGroups = useRef(false);

  const isAbleToFetchGroups =
    !isInSearchPage &&
    isSearchEnabled &&
    isMobile &&
    !alreadyFetchedGroups.current &&
    !hasErrorInRequest;

  const setAlreadyFetchedGroups = () => (alreadyFetchedGroups.current = true);

  return {
    isAbleToFetchGroups,
    setAlreadyFetchedGroups,
    hasErrorInRequest,
    sethasErrorInRequest,
  };
};
